export default __webpack_public_path__ + "static/media/developerIcon.60533f8d.png";